/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { sandboxParams } from 'app/scripts/data/plugin-iframe-sandbox';
import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { PluginView } from 'app/scripts/views/plugin/PluginView';
const t = teacupWithHelpers();

const template = t.renderable(function (content) {
  if (content == null) {
    content = {};
  }
  const { url, height } = content;
  t.iframe('.plugin-iframe', {
    allow: 'microphone; camera',
    sandbox: sandboxParams,
    src: url,
    style: height ? `height:${height}px;` : undefined,
  });
});

class PluginPopOverIFrameView extends PluginView {
  static initClass() {
    this.prototype.keepInDOM = true;

    this.prototype.vigor = this.VIGOR.NONE;
  }
  initialize({ title, content, callback }) {
    this.title = title;
    this.content = content;
    this.onDone = callback;
    return this.retain(this.onDone);
  }

  getViewTitle() {
    return this.title;
  }

  renderOnce() {
    this.$el.html(template(this.content));

    this.initIFrames(this.model);

    return this;
  }

  handleIFrameMessage(iframe, message) {
    switch (message) {
      case 'done':
        if (this.onDone != null) {
          return this.onDone({ el: iframe });
        } else {
          PopOver.hide();
          return;
        }
      default:
    }
  }
}
PluginPopOverIFrameView.initClass();
export { PluginPopOverIFrameView };
